<template>
  <div class="flex flex-col flex-1 min-h-full">
    <topbar :title="$t('surveys.page-title')" />

    <div class="flex flex-col flex-1 p-3 xl:pt-8">
      <div class="flex-1 max-w-xl xl:max-w-6xl w-full mx-auto">
        <div class="title text-brand-1 xl:font-bold xl:text-5xl">
          {{$t('quiz.compliments')}} {{$store.getters.friendlyName}}!
        </div>
        <div class="xl:text-4xl">
          <p>
            Hai sbloccato {{newMapsCount}} nuove mappe e hai ottenuto 10 punti supplementari.
          </p>
          <p>Scopri le mappe che hai contribuito a disegnare e confronta il tuo punteggio con quello delle altre persone che conosci.</p>

        </div>
      </div>
      <div class="flex flex-col xl:flex-1 max-w-md w-full mx-auto ">
        <router-link :to="{name: 'Maps'}" class="btn btn-1">
          {{$t('maps.page-label')}}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    survey: Object
  },
  computed: {
    newMapsCount() {
      return this.survey.questions.filter(q => q.template == 'multiplechoice').length;
    },
    newPointsCount() {
      return this.survey.questions.length + 5
    }
  }
}
</script>

<style>

</style>